import type { LocationQueryRaw, RouteLocationRaw } from 'vue-router'
import router from '@/router'
import { useStoreStore } from '@/stores/store'

type Name = string | undefined
type Params = { [p: string]: string | string[] | number | number[] | null | undefined }

const cache = new Map<string, RouteLocationRaw>()

export default function routeTo(
  name: Name,
  params: Params = {},
  query: LocationQueryRaw = {},
): RouteLocationRaw {
  if (!name) {
    console.trace(`Missing route name…`)
    return { name: 'NotFound' }
  }

  // make a fresh copy so we can mutate storeId without surprising callers
  const p = { ...params }
  const record = router.getRoutes().find((r) => r.name === name)
  if (!record) {
    console.error(`Route "${name}" not found`)
    return { name: 'NotFound' }
  }

  // auto-fill storeId if needed
  if (
    record.path.includes(':storeId') &&
    p.storeId == null &&
    (router.currentRoute.value.params.storeId || useStoreStore().stores.length === 1)
  ) {
    p.storeId = (router.currentRoute.value.params.storeId as string) || useStoreStore().stores[0].id
  }

  // verify
  try {
    router.resolve({ name, params: p, query })
  } catch {
    return { name: 'NotFound' }
  }

  // build a cache key
  const key = JSON.stringify({ name, params: p, query })
  if (cache.has(key)) {
    return cache.get(key)!
  }

  const to: RouteLocationRaw = { name, params: p, query }
  cache.set(key, to)
  return to
}
